type SentryFrameLike =
  | {
      filename?: string | null;
      function?: string | null;
    }
  | null
  | undefined;

type SentryEventLike = {
  exception?: {
    values?: Array<{
      type?: string | null;
      stacktrace?: {
        frames?: SentryFrameLike[] | null;
      } | null;
    } | null> | null;
  } | null;
};

export const sentryExtensionIgnoreErrors = [
  /chrome-extension:/,
  /moz-extension:/,
  /inpage\.js/,
  /extensionPageScript\.js/,
  /(?:^|[/:])injectedScript(?:\.bundle)?\.js(?:$|[?#])/,
];

const sentryExtensionFramePatterns = [...sentryExtensionIgnoreErrors, /contentscript/];

export function filterExtensionInjectedSentryEvent<T extends SentryEventLike>(event: T): T | null {
  try {
    const exception = event.exception?.values?.[0];
    const frames = exception?.stacktrace?.frames ?? [];
    const hasExtensionFrame = frames?.some((frame) => {
      const filename = frame?.filename || '';
      return sentryExtensionFramePatterns.some((pattern) => pattern.test(filename));
    });

    if (hasExtensionFrame) {
      return null;
    }

    const hasOnlyCanPlayTypeFrames =
      exception?.type === 'RangeError' &&
      frames.length > 0 &&
      frames.every((frame) => frame?.function?.includes('canPlayType'));

    if (hasOnlyCanPlayTypeFrames) {
      return null;
    }

    const isInjectedProviderRecursion =
      exception?.type === 'RangeError' &&
      frames.length > 0 &&
      frames.some((frame) => /\binject/i.test(frame?.filename || ''));

    if (isInjectedProviderRecursion) {
      return null;
    }

    return event;
  } catch {
    return event;
  }
}
